import React from 'react';
export function BonusSection() {
  const bonuses = [{
    number: '1',
    title: 'Guía de Oraciones que Sanan el Alma',
    subtitle: '30 oraciones de 3 minutos',
    features: ['Oraciones para paz interior', 'Oraciones de gratitud profunda', 'Oraciones para encontrar propósito', 'Oraciones de sanidad interior'],
    value: '$37',
    icon: '🙏'
  }, {
    number: '2',
    title: 'Rutinas Espirituales de 5 Minutos para Días Difíciles',
    subtitle: '12 prácticas rápidas',
    features: ['Para momentos de ansiedad', 'Para días de tristeza', 'Para recuperar la paz', 'Para reconectar rápidamente'],
    value: '$27',
    icon: '✨'
  }];
  return <section className="section-card" data-id="element-5">
      <div className="max-w-5xl mx-auto" data-id="element-6">
        <div className="text-center mb-12" data-id="element-7">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-8">
            Bonos Premium Incluidos
          </h2>
          <p className="text-lg text-yellow-300 font-semibold" data-id="element-9">
            Valor total: $64 — GRATIS hoy
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-10">
          {bonuses.map(bonus => <div key={bonus.number} className="bg-gradient-to-br from-purple-900/50 to-blue-900/50 backdrop-blur-sm border-2 border-yellow-400/30 rounded-xl p-8 hover:border-yellow-400/60 transition-all duration-300 hover:transform hover:scale-105" data-id="element-11">
              <div className="flex items-start gap-4 mb-6" data-id="element-12">
                <div className="text-5xl" data-id="element-13">{bonus.icon}</div>
                <div className="flex-1" data-id="element-14">
                  <div className="text-yellow-400 font-bold text-sm mb-2" data-id="element-15">
                    BONO #{bonus.number}
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-16">
                    {bonus.title}
                  </h3>
                  <p className="text-blue-300" data-id="element-17">{bonus.subtitle}</p>
                </div>
              </div>

              <ul className="space-y-3 mb-6" data-id="element-18">
                {bonus.features.map((feature, i) => <li key={i} className="text-blue-100 flex items-start" data-id="element-19">
                    <span className="text-yellow-400 mr-2 mt-1" data-id="element-20">•</span>
                    {feature}
                  </li>)}
              </ul>

              <div className="pt-4 border-t border-blue-400/20" data-id="element-21">
                <div className="flex items-center justify-between" data-id="element-22">
                  <span className="text-blue-300" data-id="element-23">Valor:</span>
                  <div className="text-right" data-id="element-24">
                    <div className="text-blue-400 line-through text-sm" data-id="element-25">
                      {bonus.value}
                    </div>
                    <div className="text-yellow-300 font-bold text-xl" data-id="element-26">
                      GRATIS HOY
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-8 p-6 bg-yellow-400/10 rounded-xl border border-yellow-400/30" data-id="element-27">
          <p className="text-white text-lg" data-id="element-28">
            <span className="font-bold" data-id="element-29">
              Estos bonos son tuyos para siempre
            </span>{' '}
            cuando eliges cualquier formato hoy
          </p>
        </div>
      </div>
    </section>;
}